module.exports = __webpack_public_path__ + "static/testimonials_bg-0c3c539b59f018267cc15153d032e7e7.png";